import { entryChannels } from '@/mocks/home';

export default function EntryBand() {
  return (
    <section id="entry" className="w-full bg-background-50">
      <div className="mx-auto max-w-[1280px] px-4 pt-12 md:px-6 md:pt-16">
        <div className="flex flex-col gap-3 md:flex-row md:items-center md:justify-between">
          <div className="flex items-center gap-3">
            <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-accent-100 text-accent-700">
              <i className="ri-links-line text-lg" />
            </span>
            <div>
              <h2 className="font-heading text-lg font-bold text-foreground-950 md:text-xl">小蓝视频官网入口</h2>
              <p className="text-xs text-foreground-500">当前可用入口 · 状态每 10 分钟检测</p>
            </div>
          </div>
          <span className="inline-flex w-fit items-center gap-1.5 whitespace-nowrap rounded-full bg-primary-100 px-3 py-1.5 font-label text-xs text-primary-700">
            <span className="h-1.5 w-1.5 rounded-full bg-primary-500" />
            3 个入口在线
          </span>
        </div>

        <div className="mt-6 grid grid-cols-1 gap-4 md:grid-cols-3">
          {entryChannels.map((entry) => (
            <div
              key={entry.id}
              className={
                entry.primary
                  ? 'flex flex-col rounded-lg border border-primary-300 bg-primary-100/50 p-5'
                  : 'flex flex-col rounded-lg border border-background-200 bg-background-100/60 p-5'
              }
            >
              <div className="flex items-center justify-between">
                <span
                  className={
                    entry.primary
                      ? 'flex h-10 w-10 items-center justify-center rounded-lg bg-primary-500 text-background-50'
                      : 'flex h-10 w-10 items-center justify-center rounded-lg bg-background-50 text-secondary-900'
                  }
                >
                  <i className={`${entry.icon} text-lg`} />
                </span>
                <span className="inline-flex items-center gap-1.5 rounded-full bg-background-50 px-2.5 py-1 font-label text-[11px] text-foreground-700">
                  <span className="h-1.5 w-1.5 rounded-full bg-primary-500" />
                  {entry.status}
                </span>
              </div>
              <h3 className="mt-4 font-heading text-base font-semibold text-foreground-950">{entry.name}</h3>
              <p className="mt-1.5 font-label text-[11px] text-foreground-500">{entry.latency}</p>
              <p className="mt-3 flex-1 text-xs leading-6 text-foreground-600">{entry.desc}</p>
              <a
                href="#entry"
                className={
                  entry.primary
                    ? 'mt-5 flex cursor-pointer items-center justify-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600'
                    : 'mt-5 flex cursor-pointer items-center justify-center gap-1.5 whitespace-nowrap rounded-md border border-background-300 px-4 py-2.5 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-700'
                }
              >
                <span className="flex h-4 w-4 items-center justify-center">
                  <i className="ri-external-link-line text-base" />
                </span>
                进入入口
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}